import { Component, OnInit } from '@angular/core';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import { VendorTerm, SalesRep, PricingTier } from 'app/core/model/entity-model';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-pricing-tier-dialog',
    templateUrl: './pricing-tier-dialog.component.html',
    styleUrls: ['./pricing-tier-dialog.component.scss'],
    standalone: false
})
export class PricingTierDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    pricingTier: PricingTier;
    displayOrder: number;

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        if (!this.pricingTier) {
            this.pricingTier = this.uow.pricingTiers.createEntity({
                displayOrder: this.displayOrder,
            }) as PricingTier;
        }
    }

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('mainValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('mainValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
